import museumFieldSpecs from '../../museum/fieldSpecs'
import programFieldSpecs from '../../program/fieldSpecs'
import guidedTourFieldSpecs from '../../guided-tour/fieldSpecs'

const isObject = (arg) => arg::Object.prototype.toString() === '[object Object]'

const fieldSpecs = {
  museum: museumFieldSpecs,
  program: programFieldSpecs,
  guidedTour: guidedTourFieldSpecs,
}

const makeKey = (obj, key) => {
  if (!isObject(obj[key])) {
    return [key]
  }

  return Object.keys(obj[key])
    .map((subKey) => makeKey(obj[key], subKey))
    .reduce((memo, keys) => {
      memo.push(...keys)
      return memo
    }, [])
    .map((subKey) => `${key}.${subKey}`)
}

export default function getSecctionsForDirtyFields(
  type,
  dirtyFields = {},
  sortedSections = []
) {
  const typeFieldSpecs = fieldSpecs[type]

  if (!isObject(dirtyFields)) {
    console.warn('`getSecctionsForDirtyFields` expects `dirtyFields` parameter to be an object! Given: ', dirtyFields)
    return []
  }

  return Object.keys(dirtyFields)
    .reduce((memo, field) => {

      memo.push(...makeKey(dirtyFields, field))
      return memo

    }, [])
    .filter((field) => field in typeFieldSpecs)
    .map((field) => typeFieldSpecs[field].section)
    .filter((section) => !!section)
    .reduce((memo, section) => {
      if (memo.indexOf(section) === -1) {
        memo.push(section)
      }
      return memo
    }, [])
    .sort((a, b) => sortedSections.indexOf(a) - sortedSections.indexOf(b))

}



// WEBPACK FOOTER //
// ./src/shared/utils/getSecctionsForDirtyFields.js